<section class="ai-section">
    <div class="container">
        <div class="card">
            <div class="page-header">
                <div>
                    <h3 class="page-title">Agent Conversations</h3>
                    <p class="page-subtitle">Every conversation of every agent: website visitors and test chats.</p>
                </div>
                <div class="flex-spacer"></div>
                <button class="btn-light btn-inline" (click)="load()"><i class="fa-solid fa-rotate"></i> Refresh</button>
            </div>

            <div class="toolbar">
                <div class="form-field">
                    <label for="cv-project">Project</label>
                    <select id="cv-project" [(ngModel)]="projectId" (ngModelChange)="onProjectChange()">
                        <option value="">All projects</option>
                        <option *ngFor="let p of projects" [value]="p.projectId">{{ p.name }}</option>
                    </select>
                </div>
                <div class="form-field">
                    <label for="cv-agent">Agent</label>
                    <select id="cv-agent" [(ngModel)]="agentId" (ngModelChange)="page = 0; applyFilters()">
                        <option value="">All agents</option>
                        <option *ngFor="let a of agentOptions" [value]="a.id">{{ a.name }}</option>
                    </select>
                </div>
            </div>

            <div class="table-wrapper table-mobile-card">
                <table class="table" id="ai-conversations-table">
                    <thead>
                        <tr>
                            <th>Started</th>
                            <th>Last message</th>
                            <th>Agent</th>
                            <th>Project</th>
                            <th>Channel</th>
                            <th>Visitor</th>
                            <th class="status-col">Status</th>
                            <th class="status-col">Messages</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="!loading && conversations.length === 0">
                            <td colspan="100%">
                                <div class="no-data"><i class="fa-solid fa-comments"></i> No conversations found</div>
                            </td>
                        </tr>
                        <tr *ngFor="let c of conversations" class="clickable" (click)="open(c)">
                            <td data-label="Started">{{ c.startedAt | date: 'MMM d, y HH:mm' }}</td>
                            <td data-label="Last message">{{ c.lastMessageAt ? (c.lastMessageAt | date: 'MMM d, y HH:mm') : '-' }}</td>
                            <td data-label="Agent" dir="auto">{{ agentName(c.agentId) }}</td>
                            <td data-label="Project">{{ projectName(c.projectId) }}</td>
                            <td data-label="Channel"><span class="badge">{{ channelLabel(c.channelType) }}</span></td>
                            <td data-label="Visitor" class="mono">{{ c.externalUserKey || '-' }}</td>
                            <td data-label="Status" class="status-col">
                                <span class="badge" [ngClass]="c.status === 'OPEN' ? 'ok' : ''">{{ c.status }}</span>
                            </td>
                            <td data-label="Messages" class="status-col">{{ c.messageCount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="pager">
                <span class="muted">{{ total }} conversations</span>
                <select [(ngModel)]="size" (ngModelChange)="page = 0; applyFilters()">
                    <option *ngFor="let s of sizes" [ngValue]="s">{{ s }} / page</option>
                </select>
                <button class="btn-light btn-sm" (click)="goTo(page - 1)" [disabled]="page === 0"><i class="fa-solid fa-chevron-left"></i></button>
                <span>Page {{ page + 1 }} of {{ totalPages }}</span>
                <button class="btn-light btn-sm" (click)="goTo(page + 1)" [disabled]="page + 1 >= totalPages"><i class="fa-solid fa-chevron-right"></i></button>
            </div>
        </div>
    </div>
</section>
